import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { AddProductParts, UpdateProductParts } from '../../actions/homeAction';

var config = {
	headers: {
		'Content-Type': 'application/json',
		Authorization: localStorage.getItem('loged_In_auth'),
	},
};

const AddProduct = () => {
	const [product, setProduct] = useState({
		name:'',
		nameAr:'',
		status:true
	})
	const [dataEdit, setDataEdit] = useState(false)
	const [image, setImage] = useState({})
	const [mediaID, setMediaID] = useState('')
	
	const dispatch = useDispatch()

	const onSave = () => {
	if(dataEdit){
        const payload = {
        //   name:product.name,
        //   status:image.status === 'false' ? false : true,
        //   media:image,
        //   brandId: singleData?.brandId
        }
        dispatch(UpdateProductParts(payload))
    } else {
        const payload = {
          name:product.name,
          nameAr:product.nameAr,
          logo:mediaID,
          status:product.status === 'false' ? false : true,
          media:image
        }
        dispatch(AddProductParts(payload))
		}
	};

	const uploadMedia = event => {
		console.log('is the image file', event.target.files[0]);

		const file = event.target.files[0];
		// var form = $('#userImage')[0];

		const reader = new FileReader(file);
		reader.readAsDataURL(file);

		if (file !== undefined) {
			reader.onloadend = () => {
				setImage({
					// image: URL.createObjectURL(file),
					image: reader.result,
				});
			};
		}

		var data = new FormData();

		// Update the formData object
		data.append('media', file);
		console.log('here upload media', file);
		axios
			.post('https://caravenue.infoware.xyz/api/media/new', data, config)

			.then(res => {
				console.log('is response', res.data.response.media[0].mediaId);
				Swal.fire({
					title: 'Upload Successfully',
					icon: 'success',
					imageUrl: './assets/images/favicon/android-chrome-192x192.png',
					imageHeight: 100,
					text: '',
					type: 'success',
					confirmButtonColor: '#3ab1f7',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Ok',
				});
				setMediaID(res.data.response.media[0].mediaId)
				setImage(res.data.response.media[0]);
			})
			.catch(err => {
				console.log(err);
				Swal.fire({
					title:
						err.response !== undefined
							? err.response.data.response.message
							: 'something went wrong Upload again!!!',
					icon: 'error',
					imageUrl: './assets/images/favicon/android-chrome-192x192.png',
					imageHeight: 100,
					text: '',
					type: 'success',
					confirmButtonColor: '#3ab1f7',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Ok',
				});
			});
	};

	const handleChange = e => {
		const{name, value} = e.target
		setProduct({...product, [name]:value})
	}

		return (
			<div className=''>
				<div className='col-md-6'>
					<div className='form-group row'>
						<div className='col-sm-9'>
							{' '}
							<h1>Add Product Master</h1>
						</div>
					</div>
				</div>
				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Product Name (En)</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='name'
										id='Product Name'
										placeholder='Product Name En'
										onChange={handleChange}
										value={product.name}
									/>
								</div>
							</div>
						</div>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Product Name (Ar)</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='nameAr'
										id='Product Name'
										placeholder='Product Name Ar'
										onChange={handleChange}
										value={product.nameAr}
									/>
								</div>
							</div>
						</div>

						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='status'
										className='form-control'
										value={product.status}
										onChange={handleChange}>
										<option>Select Status</option>
										<option value={true} name='active'>
											Active
										</option>
										<option value={false} name='inactive'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
						<div className='col-md-6'>
							<div className='row'>
								<div className='col-sm-3'> Image</div>
								<div className='col-sm-9'>
									<form
										id='userImage'
										name='userImage'
										encType='multipart/form-data'
										className='text-capitalize'>
										<div className='form-group'>
											<input
												accept='image/*'
												onChange={uploadMedia}
												id='banner_image'
												type='file'
												className='form-control'
												autoComplete='off'
												name='media'
												data-toggle='tooltip'
												title='Click To Upload Photo'
											/>
											
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
					<div className='card-footer'>
						<div className='row float-right p-3'>
								<button
									onClick={onSave}
									className='btn btn-grd-disabled mr-2'>
									<i className='icofont icofont-save'></i> Save
								</button>
							<Link to='/ProductMaster' className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}


export default AddProduct